<template>
  <footer
    v-if="footerConfig && enableFooter"
    :class="{
      mobile: isMobile,
      portrait: !orientation,
      landscape: orientation,
    }"
  >
    <footer-dynamic 
      :footerConfig="footerConfig"
    />
    <div :style="{ backgroundColor: poweredByColor }" class="antd-footer" v-if="enabledPoweredBy">
      <a-row
        type="flex"
        align="middle"
        style="max-width: 1220px;margin-left:auto;margin-right:auto;height:52px;width:100%;justify-content: center;"
        v-if="!isMobile"
      >
        <!-- <a-col flex="90px" class="poweredby">
          {{ poweredBy.label }}
        </a-col>
        <a-col class="footer-img-wrap">
          <a :href="poweredBy.url" target="_blank">
            <img
              :src="`${baseUrl}/footer/image/${poweredBy.image}`"
              alt="footer-image"
              style="height:20px;"
            />
          </a>
        </a-col>
        <div 
          class="top-arrow"
          @click="scrollTop"
        >
          <img :src="$images.carouselArrow" alt="top-arrow">
        </div> -->
        <div class="mars">
          <span>
            <b>Powered by</b>
            <img :src="$images.collectiVibeLogo" alt="logo.png" />
          </span>
          <div class="mars-part"
            v-if="poweredBy.mars_enabled"
          >
            platform developed using
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="93"
              height="12"
              viewBox="0 0 93 12"
              fill="none"
            >
              <path
                fill="#383E47"
                d="M22.6419 10.6029C22.6419 10.9457 22.5167 11.2372 22.2663 11.4772C22.016 11.7172 21.7119 11.8372 21.3542 11.8372C20.9965 11.8372 20.6925 11.7172 20.4421 11.4772C20.1917 11.2372 20.0665 10.9457 20.0665 10.6029V4.99716C20.0665 4.29431 20.0218 3.94288 19.9324 3.94288C19.8609 3.94288 19.6105 4.17431 19.1812 4.63716L13.2793 11.0657C13.0468 11.3229 12.7607 11.52 12.4209 11.6572C12.0811 11.7772 11.7144 11.8372 11.321 11.8372C10.9275 11.8372 10.5609 11.7772 10.2211 11.6572C9.88125 11.52 9.5951 11.3229 9.3626 11.0657L3.46067 4.63716C3.04933 4.17431 2.79894 3.94288 2.70952 3.94288C2.6201 3.94288 2.57538 4.29431 2.57538 4.99716V10.6029C2.57538 10.9457 2.45019 11.2372 2.19981 11.4772C1.94942 11.7172 1.64538 11.8372 1.28769 11.8372C0.93 11.8372 0.625961 11.7172 0.375577 11.4772C0.125192 11.2372 0 10.9457 0 10.6029V3.09431C0 2.4086 0.205673 1.82574 0.617019 1.34574C1.02837 0.86574 1.59173 0.62574 2.30712 0.62574C2.73635 0.62574 3.12087 0.728597 3.46067 0.934312C3.80048 1.14003 4.11346 1.3886 4.39962 1.68003L10.5698 8.41716C10.6592 8.50288 10.7665 8.59716 10.8917 8.70002C11.0348 8.78574 11.1779 8.82859 11.321 8.82859C11.464 8.82859 11.5982 8.78574 11.7234 8.70002C11.8664 8.59716 11.9827 8.50288 12.0721 8.41716L18.2155 1.68003H18.2423C18.4927 1.35431 18.7967 1.09717 19.1544 0.908597C19.5121 0.720026 19.9056 0.62574 20.3348 0.62574C21.0502 0.62574 21.6136 0.86574 22.0249 1.34574C22.4362 1.82574 22.6419 2.4086 22.6419 3.09431V10.6029Z"
              />
              <path
                fill="#383E47"
                d="M27.614 11.3743C27.3458 11.6828 27.0149 11.8371 26.6214 11.8371C26.2637 11.8371 25.9597 11.7171 25.7093 11.4771C25.4589 11.2371 25.3337 10.9457 25.3337 10.6028C25.3337 10.2942 25.4232 10.0457 25.602 9.85711L32.121 1.44854C32.425 1.05425 32.8274 0.737111 33.3282 0.497111C33.8289 0.239968 34.3655 0.111397 34.9378 0.111397C35.4743 0.111397 35.984 0.222824 36.4669 0.445682C36.9498 0.66854 37.3433 0.977111 37.6473 1.3714L44.1662 9.72854C44.2735 9.84854 44.363 9.98568 44.4345 10.14C44.506 10.2771 44.5418 10.4314 44.5418 10.6028C44.5418 10.9457 44.4166 11.2371 44.1662 11.4771C43.9159 11.7171 43.6118 11.8371 43.2541 11.8371C42.8249 11.8371 42.4851 11.6742 42.2347 11.3485L35.984 3.3514C35.8588 3.21425 35.6979 3.06854 35.5011 2.91425C35.3223 2.74283 35.1345 2.65711 34.9378 2.65711C34.741 2.65711 34.5443 2.74283 34.3476 2.91425C34.1687 3.06854 34.0257 3.21425 33.9184 3.3514L27.614 11.3743Z"
              />
              <path
                fill="#383E47"
                d="M64.4853 7.46574C64.9682 7.75716 65.46 8.07431 65.9608 8.41716C66.4615 8.74288 66.9713 9.10288 67.4899 9.49716C67.6867 9.63431 67.8566 9.79716 67.9996 9.98573C68.1427 10.1572 68.2142 10.3629 68.2142 10.6029C68.2142 10.9457 68.0891 11.2372 67.8387 11.4772C67.5883 11.7172 67.2842 11.8372 66.9266 11.8372C66.6225 11.8372 66.3185 11.7172 66.0144 11.4772C65.2812 10.9629 64.53 10.4657 63.761 9.98573C62.9919 9.50574 62.1871 9.07716 61.3466 8.70002C60.5239 8.32288 59.6654 8.02288 58.7712 7.80002C57.8769 7.57716 56.9469 7.46574 55.9812 7.46574H50.6426C50.4101 7.50002 50.2134 7.60288 50.0524 7.77431C49.8915 7.94574 49.811 8.16002 49.811 8.41716V10.6029C49.811 10.9457 49.6768 11.2372 49.4086 11.4772C49.1582 11.7172 48.8631 11.8372 48.5233 11.8372C48.1656 11.8372 47.8616 11.7172 47.6112 11.4772C47.3608 11.2372 47.2356 10.9457 47.2356 10.6029V8.13431C47.2356 7.70574 47.3161 7.30288 47.477 6.92574C47.6559 6.53145 47.8884 6.19716 48.1745 5.92288C48.4607 5.63145 48.8005 5.40859 49.194 5.25431C49.5874 5.08288 50.0167 4.99716 50.4817 4.99716H64.6999C64.9682 4.99716 65.2007 4.91145 65.3974 4.74002C65.612 4.55145 65.7193 4.32002 65.7193 4.04574C65.7193 3.7886 65.612 3.56574 65.3974 3.37717C65.2007 3.1886 64.9682 3.09431 64.6999 3.09431H48.5233C48.1656 3.09431 47.8616 2.97431 47.6112 2.73431C47.3608 2.49431 47.2356 2.20288 47.2356 1.86003C47.2356 1.51717 47.3608 1.22574 47.6112 0.98574C47.8616 0.74574 48.1656 0.62574 48.5233 0.62574H64.5926C65.0934 0.62574 65.5584 0.720026 65.9876 0.908597C66.4347 1.08003 66.8192 1.32003 67.1412 1.6286C67.481 1.93717 67.7403 2.29717 67.9191 2.7086C68.1159 3.12003 68.2142 3.56574 68.2142 4.04574C68.2142 4.52574 68.1159 4.97145 67.9191 5.38288C67.7403 5.79431 67.481 6.15431 67.1412 6.46288C66.8192 6.77145 66.4347 7.02002 65.9876 7.20859C65.5584 7.38002 65.0934 7.46574 64.5926 7.46574H64.4853Z"
              />
              <path
                fill="#383E47"
                d="M74.4603 7.46574C73.9596 7.46574 73.4945 7.38002 73.0653 7.20859C72.6361 7.02002 72.2605 6.77145 71.9386 6.46288C71.6167 6.15431 71.3573 5.79431 71.1606 5.38288C70.9818 4.97145 70.8923 4.52574 70.8923 4.04574C70.8923 3.56574 70.9818 3.12003 71.1606 2.7086C71.3573 2.29717 71.6167 1.93717 71.9386 1.6286C72.2605 1.32003 72.6361 1.08003 73.0653 0.908597C73.4945 0.720026 73.9596 0.62574 74.4603 0.62574H90.7443C91.102 0.62574 91.406 0.74574 91.6564 0.98574C91.9068 1.22574 92.032 1.51717 92.032 1.86003C92.032 2.20288 91.9068 2.49431 91.6564 2.73431C91.406 2.97431 91.102 3.09431 90.7443 3.09431H74.4067C74.1384 3.09431 73.897 3.1886 73.6823 3.37717C73.4856 3.5486 73.3872 3.77145 73.3872 4.04574C73.3872 4.30288 73.4856 4.52574 73.6823 4.71431C73.897 4.90288 74.1384 4.99716 74.4067 4.99716H89.242C89.7427 4.99716 90.2077 5.09145 90.637 5.28002C91.0841 5.45145 91.4686 5.69145 91.7905 6.00002C92.1124 6.30859 92.3628 6.67716 92.5417 7.10574C92.7384 7.51716 92.8368 7.96288 92.8368 8.44288C92.8368 8.92288 92.7384 9.36859 92.5417 9.78002C92.3628 10.1915 92.1124 10.5514 91.7905 10.86C91.4686 11.1686 91.0841 11.4086 90.637 11.58C90.2077 11.7515 89.7427 11.8372 89.242 11.8372H72.9848C72.6271 11.8372 72.3231 11.7172 72.0727 11.4772C71.8223 11.2372 71.6971 10.9457 71.6971 10.6029C71.6971 10.26 71.8223 9.96859 72.0727 9.72859C72.3231 9.48859 72.6271 9.36859 72.9848 9.36859H89.3493C89.6175 9.36859 89.85 9.28288 90.0468 9.11145C90.2435 8.92288 90.3419 8.70002 90.3419 8.44288C90.3419 8.16859 90.2435 7.93716 90.0468 7.74859C89.85 7.56002 89.6175 7.46574 89.3493 7.46574H74.4603Z"
              />
            </svg>
            <span>engine</span>
          </div>
        </div>
      </a-row>

      <!-- Mobile footer -->

      <a-row
        type="flex"
        style="max-width: 1220px;margin-left:auto;margin-right:auto;height:52px;width:100%;justify-content:center;"
        v-if="isMobile"
      >
        <!-- <a-col :span="12" class="poweredby">
          {{ poweredBy.label }}
        </a-col>
        <a-col :span="12" class="footer-img-wrap">
          <a :href="poweredBy.url" target="_blank">
            <img
              :src="`${baseUrl}/footer/image/${poweredBy.image}`"
              alt="footer-image"
              style="height:20px;"
            />
          </a>
        </a-col>
        <div class="top-arrow" v-if="ifShowArrow">
          <img :src="$images.carouselArrow" alt="top-arrow">
        </div> -->
        <div class="mars">
          <span>
            <b>Powered by</b>
            <img :src="$images.collectiVibeLogo" alt="logo.png" />
          </span>
          <div class="mars-part"
            v-if="poweredBy.mars_enabled"
          >
            platform developed using {{ poweredBy.mars_enabled }}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="93"
              height="12"
              viewBox="0 0 93 12"
              fill="none"
            >
              <path
                fill="#383E47"
                d="M22.6419 10.6029C22.6419 10.9457 22.5167 11.2372 22.2663 11.4772C22.016 11.7172 21.7119 11.8372 21.3542 11.8372C20.9965 11.8372 20.6925 11.7172 20.4421 11.4772C20.1917 11.2372 20.0665 10.9457 20.0665 10.6029V4.99716C20.0665 4.29431 20.0218 3.94288 19.9324 3.94288C19.8609 3.94288 19.6105 4.17431 19.1812 4.63716L13.2793 11.0657C13.0468 11.3229 12.7607 11.52 12.4209 11.6572C12.0811 11.7772 11.7144 11.8372 11.321 11.8372C10.9275 11.8372 10.5609 11.7772 10.2211 11.6572C9.88125 11.52 9.5951 11.3229 9.3626 11.0657L3.46067 4.63716C3.04933 4.17431 2.79894 3.94288 2.70952 3.94288C2.6201 3.94288 2.57538 4.29431 2.57538 4.99716V10.6029C2.57538 10.9457 2.45019 11.2372 2.19981 11.4772C1.94942 11.7172 1.64538 11.8372 1.28769 11.8372C0.93 11.8372 0.625961 11.7172 0.375577 11.4772C0.125192 11.2372 0 10.9457 0 10.6029V3.09431C0 2.4086 0.205673 1.82574 0.617019 1.34574C1.02837 0.86574 1.59173 0.62574 2.30712 0.62574C2.73635 0.62574 3.12087 0.728597 3.46067 0.934312C3.80048 1.14003 4.11346 1.3886 4.39962 1.68003L10.5698 8.41716C10.6592 8.50288 10.7665 8.59716 10.8917 8.70002C11.0348 8.78574 11.1779 8.82859 11.321 8.82859C11.464 8.82859 11.5982 8.78574 11.7234 8.70002C11.8664 8.59716 11.9827 8.50288 12.0721 8.41716L18.2155 1.68003H18.2423C18.4927 1.35431 18.7967 1.09717 19.1544 0.908597C19.5121 0.720026 19.9056 0.62574 20.3348 0.62574C21.0502 0.62574 21.6136 0.86574 22.0249 1.34574C22.4362 1.82574 22.6419 2.4086 22.6419 3.09431V10.6029Z"
              />
              <path
                fill="#383E47"
                d="M27.614 11.3743C27.3458 11.6828 27.0149 11.8371 26.6214 11.8371C26.2637 11.8371 25.9597 11.7171 25.7093 11.4771C25.4589 11.2371 25.3337 10.9457 25.3337 10.6028C25.3337 10.2942 25.4232 10.0457 25.602 9.85711L32.121 1.44854C32.425 1.05425 32.8274 0.737111 33.3282 0.497111C33.8289 0.239968 34.3655 0.111397 34.9378 0.111397C35.4743 0.111397 35.984 0.222824 36.4669 0.445682C36.9498 0.66854 37.3433 0.977111 37.6473 1.3714L44.1662 9.72854C44.2735 9.84854 44.363 9.98568 44.4345 10.14C44.506 10.2771 44.5418 10.4314 44.5418 10.6028C44.5418 10.9457 44.4166 11.2371 44.1662 11.4771C43.9159 11.7171 43.6118 11.8371 43.2541 11.8371C42.8249 11.8371 42.4851 11.6742 42.2347 11.3485L35.984 3.3514C35.8588 3.21425 35.6979 3.06854 35.5011 2.91425C35.3223 2.74283 35.1345 2.65711 34.9378 2.65711C34.741 2.65711 34.5443 2.74283 34.3476 2.91425C34.1687 3.06854 34.0257 3.21425 33.9184 3.3514L27.614 11.3743Z"
              />
              <path
                fill="#383E47"
                d="M64.4853 7.46574C64.9682 7.75716 65.46 8.07431 65.9608 8.41716C66.4615 8.74288 66.9713 9.10288 67.4899 9.49716C67.6867 9.63431 67.8566 9.79716 67.9996 9.98573C68.1427 10.1572 68.2142 10.3629 68.2142 10.6029C68.2142 10.9457 68.0891 11.2372 67.8387 11.4772C67.5883 11.7172 67.2842 11.8372 66.9266 11.8372C66.6225 11.8372 66.3185 11.7172 66.0144 11.4772C65.2812 10.9629 64.53 10.4657 63.761 9.98573C62.9919 9.50574 62.1871 9.07716 61.3466 8.70002C60.5239 8.32288 59.6654 8.02288 58.7712 7.80002C57.8769 7.57716 56.9469 7.46574 55.9812 7.46574H50.6426C50.4101 7.50002 50.2134 7.60288 50.0524 7.77431C49.8915 7.94574 49.811 8.16002 49.811 8.41716V10.6029C49.811 10.9457 49.6768 11.2372 49.4086 11.4772C49.1582 11.7172 48.8631 11.8372 48.5233 11.8372C48.1656 11.8372 47.8616 11.7172 47.6112 11.4772C47.3608 11.2372 47.2356 10.9457 47.2356 10.6029V8.13431C47.2356 7.70574 47.3161 7.30288 47.477 6.92574C47.6559 6.53145 47.8884 6.19716 48.1745 5.92288C48.4607 5.63145 48.8005 5.40859 49.194 5.25431C49.5874 5.08288 50.0167 4.99716 50.4817 4.99716H64.6999C64.9682 4.99716 65.2007 4.91145 65.3974 4.74002C65.612 4.55145 65.7193 4.32002 65.7193 4.04574C65.7193 3.7886 65.612 3.56574 65.3974 3.37717C65.2007 3.1886 64.9682 3.09431 64.6999 3.09431H48.5233C48.1656 3.09431 47.8616 2.97431 47.6112 2.73431C47.3608 2.49431 47.2356 2.20288 47.2356 1.86003C47.2356 1.51717 47.3608 1.22574 47.6112 0.98574C47.8616 0.74574 48.1656 0.62574 48.5233 0.62574H64.5926C65.0934 0.62574 65.5584 0.720026 65.9876 0.908597C66.4347 1.08003 66.8192 1.32003 67.1412 1.6286C67.481 1.93717 67.7403 2.29717 67.9191 2.7086C68.1159 3.12003 68.2142 3.56574 68.2142 4.04574C68.2142 4.52574 68.1159 4.97145 67.9191 5.38288C67.7403 5.79431 67.481 6.15431 67.1412 6.46288C66.8192 6.77145 66.4347 7.02002 65.9876 7.20859C65.5584 7.38002 65.0934 7.46574 64.5926 7.46574H64.4853Z"
              />
              <path
                fill="#383E47"
                d="M74.4603 7.46574C73.9596 7.46574 73.4945 7.38002 73.0653 7.20859C72.6361 7.02002 72.2605 6.77145 71.9386 6.46288C71.6167 6.15431 71.3573 5.79431 71.1606 5.38288C70.9818 4.97145 70.8923 4.52574 70.8923 4.04574C70.8923 3.56574 70.9818 3.12003 71.1606 2.7086C71.3573 2.29717 71.6167 1.93717 71.9386 1.6286C72.2605 1.32003 72.6361 1.08003 73.0653 0.908597C73.4945 0.720026 73.9596 0.62574 74.4603 0.62574H90.7443C91.102 0.62574 91.406 0.74574 91.6564 0.98574C91.9068 1.22574 92.032 1.51717 92.032 1.86003C92.032 2.20288 91.9068 2.49431 91.6564 2.73431C91.406 2.97431 91.102 3.09431 90.7443 3.09431H74.4067C74.1384 3.09431 73.897 3.1886 73.6823 3.37717C73.4856 3.5486 73.3872 3.77145 73.3872 4.04574C73.3872 4.30288 73.4856 4.52574 73.6823 4.71431C73.897 4.90288 74.1384 4.99716 74.4067 4.99716H89.242C89.7427 4.99716 90.2077 5.09145 90.637 5.28002C91.0841 5.45145 91.4686 5.69145 91.7905 6.00002C92.1124 6.30859 92.3628 6.67716 92.5417 7.10574C92.7384 7.51716 92.8368 7.96288 92.8368 8.44288C92.8368 8.92288 92.7384 9.36859 92.5417 9.78002C92.3628 10.1915 92.1124 10.5514 91.7905 10.86C91.4686 11.1686 91.0841 11.4086 90.637 11.58C90.2077 11.7515 89.7427 11.8372 89.242 11.8372H72.9848C72.6271 11.8372 72.3231 11.7172 72.0727 11.4772C71.8223 11.2372 71.6971 10.9457 71.6971 10.6029C71.6971 10.26 71.8223 9.96859 72.0727 9.72859C72.3231 9.48859 72.6271 9.36859 72.9848 9.36859H89.3493C89.6175 9.36859 89.85 9.28288 90.0468 9.11145C90.2435 8.92288 90.3419 8.70002 90.3419 8.44288C90.3419 8.16859 90.2435 7.93716 90.0468 7.74859C89.85 7.56002 89.6175 7.46574 89.3493 7.46574H74.4603Z"
              />
            </svg>
            <span>engine</span>
          </div>
        </div>
      </a-row>

    </div>
  </footer>
</template>

<script>
import FooterDynamic from "./FooterDynamic.vue";
import isMobileMixin from "@/mixins/isMobileMixin";
import api from "@/api";

export default {
  components: {
    FooterDynamic,
  },
  mixins: [isMobileMixin],
  props: {
    orientation: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      footerConfig: null,
    };
  },
  computed: {
    poweredBy () {
      return this.footerConfig.powered_by;
    },
    poweredByColor () {
      return this.footerConfig.color.powered_by_color;
    },
    enabledPoweredBy () {
      return this.footerConfig.powered_by.enabled;
    },
    ifShowArrow () {
      return !!this.footerConfig.scroll_to_top.value;
    },
    enableFooter () {
      return !!this.footerConfig.enable_footer.value;
    },
    baseUrl () {
      return process.env.VUE_APP_API_URL;
    },
  },
  mounted () {
    this.init();
  },
  methods: {
    async init () {
      this.getFooterConfig();
    },
    async getFooterConfig () {
      try {
        const res = await api.getFooterConfig();
        console.log(res.data.footer);
        this.footerConfig = res.data.footer;
      } catch (error) {
        console.warn(error);
      }
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    openLink (link) {
      window.open(link, '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
* {
  font-family: 'Roboto';
}

.footer-link {
  font-size: 16px;
  line-height: 18px;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  color: #ffffff;
  text-decoration: underline;
}

.poweredby {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #9ca3af;
}

.copyright {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  color: #001529;
  font-size: 14px;
  line-height: 16px;
  text-align: right;
}

.footer-wrap {
	margin-left: var(--nav-height);
	width: calc(100% - var(--nav-height));
	height: var(--footer-height);
	background: #f2f2f2;
	box-shadow: 0px 4px 100px rgba(0, 0, 0, 0.25);
	position: relative;
	margin-bottom: 0;
	&.portrait {
		margin-left: 0;
		width: 100%;
		margin-bottom: var(--nav-height);
		height: var(--nav-height);
	}
}
.logo-wrap {
	margin-left: 20px;
	max-width: calc(min(25vw, 150px));
	display: flex;
	justify-content: center;
	align-items: center;
	&.mobile.portrait {
		max-width: calc(min(30vw, 150px));
	}
	a {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
.content-wrap {
	padding: 0 10px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: nowrap;
	height: 100%;
}

.links-wrap {
	width: calc(100% - 200px);
	&.mobile.portrait {
		width: calc(100% - calc(min(40vw, 300px)));
	}
	display: flex;
	justify-content: space-evenly;
	flex-direction: row;
	&.mobile.portrait {
	flex-direction: column;
	}
	a {
		color: #0000006c;
		display: block;
		font-size: 0.8rem;
		cursor: pointer;
		margin: 3px 15px;
	}
}
.top-arrow {
  $size: 32px;
  width: $size;
  height: $size;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.17);
  border-radius: 50%;
  position: absolute;
  right: 10px;
  cursor: pointer;
  img {
    width: 8px;
    height: 11px;
    transform: rotate(90deg);
    margin-bottom: 1px;
  }
}

.mars {
  display: flex;
  align-items: center;
  svg {
    padding: 0 10px;
    margin-bottom: 2px;
  }
  img {
    max-height: 12px;
    margin: 0 8px 5px 8px;
  }
}
</style>
